import React, { Component } from 'react';
import PropTypes from 'prop-types'
import AppStore from '../../stores/AppStore';
import GuestSubmitButton from '../../components/guest-submit-button';
import { formatAmount, getPhoneNumberWithoutCountryCode, getGriffinPhoneHandler } from '../../utility/formator';
import templateData, { guestLocalsMessages } from '../../utility/getTemplateData';
import CancelAndReturn from '../../components/cancelAndReturn';
import * as DonateAppActions from '../../actions/AppActions';
import { guestPayment as teslaGuestPayment } from './teslaHelper';
import { withRouter } from 'react-router-dom';
import _get from 'lodash/get';
import withDonate from '../../components/guest/WithDonate';
import * as AppConstants from '../../utility/constants';
import AppDispatcher from '../../dispatcher/AppDispatcher'
import { isTeslaErrorMessage } from '../../utility/teslaUtility';
import * as FPT from '../../utility/fpt';
import _find from 'lodash/find';
let SignupApp;
let AppActions;

const initialData = JSON.parse(document.getElementById('initialData').innerHTML || {});
const allGuestMessages = guestLocalsMessages();

export class TeslaForm extends Component {
	constructor(props) {
		super(props);

		SignupApp = props.signupApp;
		AppActions = props.appActions;

		this.state = {
			formattedAmount: this.getFormattedAmount(),
			hasLogo: templateData.hasLogo,
			subHeaderLabel: templateData.donationName,
			orgName: templateData.charityName,
			donationId: templateData.donationId,
			guestRedirectUrl: templateData.guestRedirectUrl,
			donateDisabled: false,
			showServiceErrors: false,
			errorMessages: [],
			recurringEnabled: templateData.recurringEnabled,
			recurringStatus: false,
			country: initialData.selectedCountry,
			selectedCountry: initialData.selectedCountry,
			charityCountry: templateData.charityCountry,
			memberMandatory: templateData.memberMandatory || false,
			accountCreationTriggered: false,

			recurringHelpText: '',
			recurringLabel: 'Make this a monthly donation',
			isDonating: false,
			isShipping: templateData.isShipping || false,
			shareAddress: {},
			progressiveComponentLoaded: false,
			paymentProcessing: false,
			programNames: templateData.donateContext.program_names
		};
		
		this.dispatcherMessages = AppDispatcher.register((payload) => {
			const actionType = _get(payload, 'action.actionType');

			if (actionType === AppConstants.CHANGE_RECURRING) {
				const status = _get(payload, 'action.item.recurring', '') === 'checked';

				if (!this.state.memberMandatory) {
					this.state.reduxStore.dispatch({
						type: 'UPDATE_EXTERNAL_VALUES',
						value: {
							paypalAccountData_memberMandatory: { visible: !status, value: status },
							password_TCPA_Fields_dynamicSection: status,
							paypalAccountData_guestTermsAgree: { visible: !status },
							paypalFormData_paragraphOne: { visible: !status },
							paypalFormData_fieldGroupHeading: { visible: status }
						}
					});
				}
			}
		});
	}

	componentWillUnmount() {
		AppDispatcher.unregister(this.dispatcherMessages);
	}

	getFormattedAmount = () => {
		const currency = AppStore.getDonationCode() || '';
		const amount = AppStore.getDonationAmount();
		let formattedAmount = '';
		if (amount) {
			formattedAmount = formatAmount({ currency, value: amount })
		}
		return formattedAmount
	}

	/**********
	Calls dispatch on progressive redux store to add values to specific fields
	Also adds donor name to store, and determines to render the 'memberMandatory view
	**********/
	setInitialState = (store) => {
		console.log('setInitialState called with store ', store);
		const senderDetails = initialData.senderDetails || {};
		const prefillAddress = senderDetails.address || {};
		const prefillPhone = senderDetails.phone || {};

		if (store.getState().formFields.fieldState) {
			store.dispatch({
				type: 'UPDATE_EXTERNAL_VALUES',
				value: {
					paypalAccountData_address1: { value: prefillAddress.address1 || '' },
					paypalAccountData_address2: { value: prefillAddress.address2 || '' },
					paypalAccountData_city: { value: prefillAddress.city || '' },
					paypalAccountData_state: { value: prefillAddress.state || '' },
					paypalAccountData_zip: { value: prefillAddress.zip || '' },
					paypalAccountData_firstName: { value: senderDetails.first_name || '' },
					paypalAccountData_lastName: { value: senderDetails.last_name || '' },
					paypalAccountData_email: { value: senderDetails.sender_email || '' },
					paypalAccountData_phone: { value: getPhoneNumberWithoutCountryCode(prefillPhone.phone_number) || '' },
					paypalAccountData_memberMandatory: { value: this.state.memberMandatory || false },
					paypalAccountData_shareAddress: { visible: this.state.isShipping },
					password_TCPA_Fields_dynamicSection: false,
					paypalAccountData_guestTermsAgree: { visible: true },
					paypalFormData_paragraphOne: { visible: true },
					paypalFormData_fieldGroupHeading: { visible: false }
				}
			});
		}

		if (!store.getState().donorName) {
			store.dispatch({
				type: 'UPDATE_FORM_FIELD_STATES',
				value: [{ donorName: templateData.donationName }]
			});
		}

		this.setState({ reduxStore: store, reduxStoreState: store.getState() });

		if (this.state.memberMandatory || AppStore.getDonationRecurring() === 'checked') {
			store.dispatch({
				type: 'UPDATE_EXTERNAL_VALUES',
				value: {
					paypalAccountData_memberMandatory: { visible: false, value: true },
					password_TCPA_Fields_dynamicSection: true,
					paypalAccountData_guestTermsAgree: { visible: false },
					paypalFormData_paragraphOne: { visible: false },
					paypalFormData_fieldGroupHeading: { visible: true }
				}
			});
		}
	};

	/**
	 * Appends error messages from onboarding redux store
	 * to react's errorMessage state
	 *
	 * @author: mdemers
	 * @param {Object} cardData The cardData error object from redux store
	 * @param {Object} paypalAccountData The paypalAccountData error object from redux store
	 */
	updateErrorMessages = (cardData, paypalAccountData) => {
		const errorMessages = this.state.errorMessages;

		if (cardData.errorCode) {
			if (isTeslaErrorMessage(cardData.errorCode)) {
				if (!_find(errorMessages, { value: cardData.message })) {
					errorMessages.push({ value: cardData.message })
				}
			} else {
				this.props.handlePaymentFailure()
			}
		}

		if (paypalAccountData.errorCode) {
			if (isTeslaErrorMessage(paypalAccountData.errorCode)) {
				if (!_find(errorMessages, { value: paypalAccountData.message })) {
					errorMessages.push({ value: paypalAccountData.message })
				}
			} else {
				this.props.handlePaymentFailure()
			}
		}

		const showServiceErrors = this.state.errorMessages.length > 0 ? true : false

		this.setState({
			errorMessages: errorMessages,
			showServiceErrors: showServiceErrors
		})
	};

	/*
	* handleMemberFailure
	* Redirect all member failure to donate/member
	* Known case
	* Case 1 :- WSM_PAYER_FUNDING_INSTRUMENTS_UNAVAILABLE
	* Case 2 :- WSM_VALIDATION_ERROR
	*/
	handleMemberFailure = () => {
		if (this.state.isDonating) {
			return;
		}
		// Will be removed when onboarding component will return status using callback
		// Using isDonating to block duplicate call - need to synchronous
		this.state.isDonating = true; // eslint-disable-line
		this.props.handleMemberFailure();
	}

	/**********************
	UpdateReduxStore, passed to Progressive Component.
	Simply takes the state object from the store, and throws it in container state
	**********************/
	updateReduxStore = (store) => {
		const {
			appState: {
				appBusy,
				pageFlowData: {
					// serviceData = {},
					// serviceData: {
					// 	userAccountData = {}
					// } = {},
					sessionStatus = {}
				} = {}
			} = {}
		} = store.getState();
		
		const {
			paypalAccountData_donateCountryselector = {},
			paypalAccountData_shareAddress = {}
		} = store.getState().formFields.fieldState;

		const hasFormError = _get(store.getState(), 'formFields.hasFormError', {});
		const paypalAccountData = _get(store.getState(), 'appState.pageFlowData.errors.paypalAccountData', {});
		const cardData = _get(store.getState(), 'appState.pageFlowData.errors.cardData', {});
		const hasErrors = paypalAccountData.errorCode || cardData.errorCode || hasFormError ? true : false

		const isFullUser = sessionStatus.paypalAccount === 'exists';
		const isGuestUser = sessionStatus.guestAccount === 'exists';
		const isCardAdded = sessionStatus.card === 'exists';
		const paymentProcessing = this.state.paymentProcessing;

		/*
		* Need to presist value shareAddress checkbox
		* after completion of `/welcome/donate, redux store is reset and shareAddress checkbox value changes to false
		*/
		if (this.state.shareAddress !== paypalAccountData_shareAddress) {
			this.setState({ shareAddress: paypalAccountData_shareAddress });
		}

		this.setState({ isAppBusy: appBusy })
		this.props.toggleSpinner(appBusy, this.state.isDonating);

		/*
		* ERROR CASE 1:- Guest full user add card failed
		* Full user account is created successfully
		* Card additon failed
		* Updating flux store with any card error
		* User is logged in
		* User will be redirected to /member
		* Member route will take care - to add new funding instrument
		*/
		if (isFullUser && !isCardAdded) {
			DonateAppActions.updateAddCardError('exists');
			return this.props.handleMemberFailure();
		}

		/*
		* Continue with donation
		* Account is created successfully
		* Card is added
		* User is logged in or not
		*
		* In-case of guest user - if not logged in - will try to get payeeId from mayFly
		* TODO: adding middleware - to accept unautorized guest user and make final attempt to login by getting payeeId from mayFly
		*/
		if ((isFullUser || isGuestUser) && !hasErrors && !paymentProcessing) {
			return this.processPayment();
		}

		/*
		*  for handling the country change based on the store value change for the country dropdown.
		*
		*/

		if (paypalAccountData_donateCountryselector && this.state.country !== paypalAccountData_donateCountryselector.value) {
			/*****
			The updateReduxStore() method is called every time an action is dispatched to the

			progressive store.
			That means the condition above is checked every time an action is dispatched.

			In the ProgressiveOnboarding component, there are two dispatches fired off in
			onChange() of the country drop down select field. That means the updateReduxStore() method
			is fired twice, and this check is made twice.

			this.setState() is asynchronous. Updating our state with this.setState() was two slow, and
			there isn't a way to make this.setState() synchronous. So, to avoid
			this.handleCountryChange() being fired twice(once for each dispatch), and sending two
			/donate/update/donation requests, we set the state directly, making it synchronous, and
			change this.state.country before the next updateReduxStore() is fired. When the second one is
			fired, this.state.country will have changed, and this.handleCountryChange will not fire again.

			Because we are not relying on this.state.country to trigger a re-render, and only using it
			for a condition to ultimately redirect the page, this is an appropriate departure from
			React's way of managing state.
			*****/

			this.state.country = paypalAccountData_donateCountryselector.value; // eslint-disable-line
			this.props.handleCountryChange(paypalAccountData_donateCountryselector.value);
		}


		// log fpti errors and scroll to field level errors
		if (hasErrors && this.state.accountCreationTriggered && !appBusy) {
			if (cardData.errorCode) {
				FPT.trackError({ message: cardData.message, fieldId: 'global error', code: cardData.errorCode })
			}

			if (paypalAccountData.errorCode) {
				FPT.trackError({ message: paypalAccountData.message, fieldId: 'global error', code: paypalAccountData.errorCode })
			}
			this.state.accountCreationTriggered = false; // eslint-disable-line

			this.setState({
				accountCreationTriggered: false
			}, () => {
				this.props.handleScrollToError()
			});

		}

		this.updateErrorMessages(cardData, paypalAccountData);
	};

	/*
	* updateShareAddress
	* setting value of shareAddress checkbox before onboarding dispatched any event
	* shareAddress checkbox value is used by planning
	*/
	updateShareAddress = () => {
		DonateAppActions.updateShareAddress(this.state.shareAddress.value);
	};

	triggerAccountCreation = (event) => {
		event.preventDefault();
		if (!this.props.validateAmountV2()) {
			return;
		}

		const fieldId = event.target.id || event.target.name || event.target.innerText || event.target.href;
		this.state.accountCreationTriggered = true; // eslint-disable-line
		DonateAppActions.updateServerErrors({
			serverErrors: []
		});
		this.updateShareAddress();
		this.state.reduxStore.dispatch(
			AppActions.submitFormAjax(
				'/appData/action',
				'submit_account_create',
				[
					{ key: '/paypalAccountData/createUpdateReady', value: true },
					{ key: '/cardData/createUpdateReady', value: true }
				],
				fieldId
			)
		);
	};

	/*
	* processDonation
	*/
	processPayment = (params = {}) => {
		this.setState({ paymentProcessing: true })
		if (this.state.isDonating) {
			return;
		}
		// Send 'selectedProgram' param to server
		params.selectedProgram = AppStore.getSelectedProgram();

		// Will be removed when onboarding component will return status using callback
		// Using isDonating to block duplicate call - need to synchronous
		this.state.isDonating = true; // eslint-disable-line
		teslaGuestPayment(params).then((response = {}) => {
			this.setState({ isDonating: false })

			if (response.code === 'CROSS_BORDER' && response.fundingOpts) {
				const fundingOptions = response.fundingOpts[0];

				// Updating store with funding options and redirecting to review page
				DonateAppActions.updateFundingOptions({ fundingOptions })
				this.setState({ isDonating: false })
				return this.props.history.push('/donate/guest/crossborder');
			} else if (response.error && response.error.auth_state === 'LOGGEDIN') {
				return this.props.handleMemberFailure();
			} else if (response.error && response.code === 'CVV_CONTINGNECY') {
				const errorMessages = this.state.errorMessages;
				errorMessages.push({ value: 'Please check credit card information or try another card' })

				DonateAppActions.updateServerErrors({
					serverErrors: errorMessages
				});
				
				return;
			} else if (response.data.error) {
				// mocking fulfillment error and render user back to tesla form
				this.setState({ isDonating: true });
				window.location.href = this.props.getDonateGuestUrl();
				return;
			} else if (response.confirmation) {
				DonateAppActions.updateConfirmation({ confirmation: response.confirmationData });
				return this.props.handlePaymentSuccess(response);
			}

			return this.props.handlePaymentFailure();
		}).catch((err) => {
			console.log('processDonation err :: ', err);
			this.setState({ isDonating: false })
			return this.props.handlePaymentFailure(err);
		})
	};

	renderProgressive = () => {
		let progressiveOnboardingProps = {
			updateReduxStore: this.updateReduxStore,
			modelData: {},
			token: templateData.token,
			setInitialState: this.setInitialState,
			// endpoint: `/welcome/donate?country.x=${templateData.country}&locale.x=${templateData.language}_${templateData.country}`,
			griffinData: true,
			griffinPhoneHandler: getGriffinPhoneHandler()
		};
		
		if (templateData.token === templateData.teslaToken && templateData.teslaVisited === true) {
			progressiveOnboardingProps.endpoint = `/welcome/donate?country.x=${templateData.country}&locale.x=${templateData.language}_${templateData.country}&entry=false`;
		} else {
			progressiveOnboardingProps.endpoint = `/welcome/donate?country.x=${templateData.country}&locale.x=${templateData.language}_${templateData.country}&entry=true`;
		}

		return (
			<div className="donate_onboarding_guest_form">
				<SignupApp {...progressiveOnboardingProps} />
				<GuestSubmitButton
					amount={this.state.formattedAmount}
					labels={allGuestMessages.guestLabels}
					isRecurring={this.state.recurringStatus}
					// disabled={this.props.donateDisabled}
					country={this.state.country}
					handleClick={this.triggerAccountCreation}
					// passwordFieldsOpen={this.state.passwordFieldsOpen}
				/>
				<CancelAndReturn />
			</div>
		)
	}

	render() {
		return this.renderProgressive();
	}
}

TeslaForm.propTypes = {
	signupApp: PropTypes.func,
	appActions: PropTypes.object,
	handlePaymentFailure: PropTypes.func,
	handleMemberFailure: PropTypes.func,
	toggleSpinner: PropTypes.func,
	handleCountryChange: PropTypes.func,
	handleScrollToError: PropTypes.func,
	validateAmountV2: PropTypes.func,
	handlePaymentSuccess: PropTypes.func,
	history: PropTypes.object,
	getDonateGuestUrl: PropTypes.func
}

export default withRouter(withDonate(TeslaForm));



// WEBPACK FOOTER //
// ./pages/guest/teslaForm.js